import { create } from "zustand";

type Theme = "light" | "dark";

interface UiState {
  theme: Theme;
  setTheme: (t: Theme) => void;
  toggleTheme: () => void;
}

function readInitialTheme(): Theme {
  if (typeof document === "undefined") return "light";
  return document.body.classList.contains("theme-dark") ? "dark" : "light";
}

function applyTheme(t: Theme): void {
  document.body.classList.remove("theme-light", "theme-dark");
  document.body.classList.add(`theme-${t}`);
  localStorage.setItem("neo-theme", t);
}

export const useUiStore = create<UiState>((set, get) => ({
  theme: readInitialTheme(),
  setTheme: (t) => {
    applyTheme(t);
    set({ theme: t });
  },
  toggleTheme: () => {
    const next: Theme = get().theme === "dark" ? "light" : "dark";
    applyTheme(next);
    set({ theme: next });
  },
}));
